module.exports = "https://web-assets.ifttt.com/packs/media/location_field/location_enter-6fee2008.svg";